module.exports = __webpack_public_path__ + "static/media/financepic2@3x.c37310a9.png";